export enum BadgeType{
    Critical="Critical",
    Caution="Caution",
    Info="Info",
    Standard ="Standard"
}
export interface IStatusBadgeProps{
    type?:BadgeType,
    onClick?:  any,
    backgroundColour?: string,
    fontColour?: string,
    width?: string,
    name?:string,
    cursor?:string
}
